"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./style.scss");
const Label = (props) => {
    const { htmlFor, className = '', children, onClick, required = false } = props;
    const handleOnClick = (event) => {
        if (onClick)
            onClick(event);
    };
    return ((0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: htmlFor, className: `label ${required ? 'required' : ''}${className}`, onClick: handleOnClick }, { children: children })));
};
exports.default = Label;
